import PropTypes from 'prop-types'

import { MotionBox, YumiBasic } from '@redriverpress/system'

// Use of position: relative and z-index: 1 fixes a known rendering bug
// in Safari when using overflow: hidden on elements with border-radius
// appled to them. Neat!

const bgs = {
  happy: 'green100',
  neutral: 'blue400',
  sad: 'yellow400',
}

export default function ResultsYumi({ mood, ...props }) {
  return (
    <MotionBox
      size='7rem'
      p={2}
      borderRadius='circular'
      bg={bgs[mood]}
      display='inline-flex'
      justifyContent='center'
      overflow='hidden'
      position='relative'
      zIndex={1}
      initial={{ opacity: 0, scale: 0 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{
        type: 'spring',
        damping: 20,
        stiffness: 250,
        delay: 0.2,
      }}
      {...props}
    >
      <MotionBox
        display='flex'
        width={1}
        style={{ originY: 1 }}
        animate={{
          opacity: [0, 1, 1, 1, 1, 1, 1, 1],
          y: [25, -6, 0, 0, -6, 0, -6, 0],
          rotate: [0, 0, 0, 0, -3, 0, 3, 0],
        }}
        transition={{
          delay: 0.4,
          times: [0, 0.15, 0.2, 0.5, 0.6, 0.7, 0.8, 0.9],
          duration: 2,
        }}
      >
        <YumiBasic blink sad={mood === 'sad'} position='relative' top={3} />
      </MotionBox>
    </MotionBox>
  )
}

ResultsYumi.defaultProps = {
  mood: 'happy',
}

ResultsYumi.propTypes = {
  mood: PropTypes.oneOf(['happy', 'neutral', 'sad']),
}
